import { LOCALES_ISO, type LocaleIso } from '../i18n/locale';

/**
 * Locales that have sitemap files generated by the Gatsby build
 */
const ALLOWED_SITEMAP_LOCALES: LocaleIso[] = ['de-DE', 'de-AT', 'de-CH', 'de-LU'];

/**
 * Generates the URL to the sitemap-index.xml file in the Google Cloud Storage bucket.
 * The sitemap files are currently generated by the Gatsby build and uploaded to GCS.
 *
 * @param locale - The locale in ISO format (e.g., 'de-DE')
 * @param branch - The branch name (default: 'master')
 * @returns The full URL to the sitemap-index.xml file, or null if locale doesn't have a sitemap
 *
 * @example
 * getSitemapUrl('de-DE') // 'https://assets.pixum.com/static-website/master/de_DE/sitemap-index.xml'
 * getSitemapUrl('de-AT') // 'https://assets.pixum.com/static-website/master/de_AT/sitemap-index.xml'
 * getSitemapUrl('es-ES') // null (not in allowed locales)
 */
export function getSitemapUrl(locale: LocaleIso, branch = 'master'): string | null {
  // Check if this locale has a sitemap
  if (!ALLOWED_SITEMAP_LOCALES.includes(locale)) {
    return null;
  }

  // Convert locale from ISO format (de-DE) to underscore format (de_DE)
  const localeUnderscore = LOCALES_ISO[locale];

  // Build the URL to the sitemap in the GCS bucket
  const baseUrl = 'https://assets.pixum.com/static-website';

  return `${baseUrl}/${branch}/${localeUnderscore}/sitemap-index.xml`;
}

/**
 * Checks if the given locale has a sitemap available
 */
export function hasSitemap(locale: LocaleIso): boolean {
  return ALLOWED_SITEMAP_LOCALES.includes(locale);
}
